export enum RequestMethod {
  DELETE = 'DELETE',
  GET = 'GET',
  OPTIONS = 'OPTIONS',
  PATCH = 'PATCH',
  POST = 'POST',
  PUT = 'PUT',
}

export const DEFAULT_METHOD = RequestMethod.GET
export const DEFAULT_PROTOCOL = 'https'

export const BACKEND_SERVER = 'backend-mock.prod.mock.aservices.tech'
